import { render, staticRenderFns } from "./client-select.vue?vue&type=template&id=2c424348&scoped=true&"
import script from "./client-select.vue?vue&type=script&lang=js&"
export * from "./client-select.vue?vue&type=script&lang=js&"
import style0 from "./client-select.vue?vue&type=style&index=0&id=2c424348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c424348",
  null
  
)

export default component.exports